<div class="login-page">
  <main class="login-main">
    <div class="login-wrap">
      <div class="login-hero">
        <div class="login-mascot">
          <img src="assets/images/walley-bot.png" alt="Walley" />
        </div>
        <p class="login-tagline">{{ 'LOGIN.ENT_TAGLINE' | translate }}</p>
      </div>

      <div class="login-card glass-card auth-card" appInViewport>
        <app-back-button class="auth-back-btn" (back)="goLogin()" ariaLabel="Torna al login"></app-back-button>
        <div class="auth-flow-body">
          <h2 class="auth-flow-title">{{ 'RESET-PASSWORD.TITLE' | translate }}</h2>
          <p class="auth-flow-subtitle">{{ 'RESET-PASSWORD.SUBTITLE' | translate }}</p>
          <form [formGroup]="resetPwdForm" (submit)="$event.preventDefault()" class="login-form">
            <div class="login-field">
              <label class="login-label" for="new_password">{{ 'LOGIN.PASSWORD' | translate }}</label>
              <div class="login-input-wrap">
                <i class="bi bi-lock login-input-icon" aria-hidden="true"></i>
                <input
                  [type]="type1"
                  name="new_password"
                  id="new_password"
                  formControlName="new_password"
                  class="login-input login-input--pwd"
                  [class.login-input--invalid]="errorMessage && !validPassword"
                  autocomplete="new-password"
                  (input)="checkPsw()"
                />
                <button type="button" class="login-toggle-pwd" (click)="seePassword('new_password')" [attr.aria-label]="toggled1 ? 'Show password' : 'Hide password'">
                  <i class="bi" [ngClass]="{ 'bi-eye': !toggled1, 'bi-eye-slash': toggled1 }"></i>
                </button>
              </div>
            </div>

            <div class="login-field">
              <label class="login-label" for="confirm_password">{{ 'RESET-PASSWORD.FIELD_PWDREPEAT' | translate }}</label>
              <div class="login-input-wrap">
                <i class="bi bi-lock login-input-icon" aria-hidden="true"></i>
                <input
                  [type]="type2"
                  name="confirm_password"
                  id="confirm_password"
                  formControlName="confirm_password"
                  class="login-input login-input--pwd"
                  [class.login-input--invalid]="errorMessage && (!validPassword || !equalPassword)"
                  autocomplete="new-password"
                  (input)="checkPsw()"
                />
                <button type="button" class="login-toggle-pwd" (click)="seePassword('confirm_password')" [attr.aria-label]="toggled2 ? 'Show password' : 'Hide password'">
                  <i class="bi" [ngClass]="{ 'bi-eye': !toggled2, 'bi-eye-slash': toggled2 }"></i>
                </button>
              </div>
            </div>

            @if (errorMessage && !validPassword) {
              <div class="login-field-error" role="alert">
                <small>{{ 'RESET-PASSWORD.MSG_ERRORSLENGTH' | translate }}</small>
              </div>
            }
            @if (errorMessage && !equalPassword) {
              <div class="login-field-error" role="alert">
                <small>{{ 'RESET-PASSWORD.MSG_ERRORSDIFFERENT' | translate }}</small>
              </div>
            }

            <button type="button" class="login-submit" (click)="resetPassword()" [disabled]="!resetPwdForm.touched">
              <span>{{ 'RESET-PASSWORD.BUTTON_SEND' | translate }}</span>
              <i class="bi bi-arrow-right" aria-hidden="true"></i>
            </button>
          </form>
        </div>
      </div>

      <div class="login-trust">
        <i class="bi bi-shield-check" aria-hidden="true"></i>
        <p>Walley - ERP</p>
      </div>
    </div>
  </main>
</div>
